import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { UnsavedChangesDialogComponent } from '../components/unsaved-changes-dialog/unsaved-changes-dialog.component';
import { HasUnsavedChanges } from '../models/has-unsaved-changes';

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component): Observable<boolean> => {
  const dialog = inject(MatDialog);

  if (component.submitted()) {
    return of(true);
  }

  if (component.hasUnsavedChanges()) {
    return dialog
      .open(UnsavedChangesDialogComponent, {
        width: '465px',
        disableClose: true,
        data: {},
      })
      .afterClosed();
  }

  return of(true);
};
